import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import AboutPage from "../AboutPage";
import HomePageOld from "../HomePageOld";
import ServiceSinglePage from "../ServiceSinglePage";
import ScrollToTop from "../../components/ScrollToTop";

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
      <ScrollToTop />
        <Routes>
          <Route exact path="/" element={<HomePageOld />} />
          <Route path="/desenvolvimento-de-carreira" element={<AboutPage />} />
          <Route path="/recursos-humanos" element={<ServiceSinglePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
